import Avatar from "../../../../assets/avatar.svg";

export const TASK_NAME_LIMIT = 250;
export const TASK_DESC_LIMIT = 10000;
export const TIME_VARIANTS = [1, 2, 3, 4, 5, 6, 7, 8];
export const RESPONSIBLE_PLACEHOLDER = {
    id: -1,
    name: "Не выбран",
    picture: Avatar,
};